export { default as useKanji } from './use-kanji'
